import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import styles from 'src/components/lead-sidebar/LeadSidebarExpandableItem.module.css';

interface Props {
    title: string;
    children: React.ReactNode;
    action?: React.ReactNode;
    tooltipTitle?: string;
    defaultExpanded?: boolean;
    className?: string;
}

export default function LeadSidebarExpandableItem({
    title,
    children,
    action,
    tooltipTitle,
    defaultExpanded = true,
    className,
}: Props) {
    return (
        <div className={styles.wrapper}>
            <Accordion
                defaultExpanded={defaultExpanded}
                disableGutters
                elevation={0}
                square
                className={className}
                sx={{ '&::before': { display: 'none' } }}
            >
                <AccordionSummary
                    expandIcon={<KeyboardArrowDownIcon />}
                    sx={{ px: 0 }}
                >
                    <Tooltip title={tooltipTitle}>
                        <Typography className={styles.summaryTitle}>{title}</Typography>
                    </Tooltip>
                </AccordionSummary>

                <AccordionDetails
                    sx={{ pl: 0, pr: 1, py: 0.5 }}
                >
                    {children}
                </AccordionDetails>
            </Accordion>
            {action && (
                <div className={styles.actionOverlay}>
                    {action}
                </div>
            )}
        </div>
    );
}
